import React, { useState } from "react";
import {
  FaUser,
  FaLock,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import "../Components/Loginpage.css";
import logo from "../Components/images/MAS Logo Text.png";
import { useNavigate } from "react-router-dom";
import {
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../firebase-config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Loginpage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username.trim() || !password.trim()) {
      toast.error("Please fill all fields");
      return;
    }

    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        username.trim(),
        password
      );

      const user = userCredential.user;

      // Allow only your admin email
      if (user.email !== "masmobilityservices@gmail.com") {
        toast.error("Unauthorized User ❌");
        setLoading(false);
        return;
      }

      // Store user in localStorage
      localStorage.setItem(
        "ownerUser",
        JSON.stringify({
          uid: user.uid,
          email: user.email,
        })
      );

      toast.success("Login Successful ✅");

      setTimeout(() => {
        navigate("/ownerpage", { replace: true });
      }, 1500);
    } catch (error) {
      console.error("Login Error:", error);

      switch (error.code) {
        case "auth/invalid-credential":
        case "auth/wrong-password":
          toast.error("Incorrect Email or Password ❌");
          break;

        case "auth/user-not-found":
          toast.error("No account found ❌");
          break;

        case "auth/invalid-email":
          toast.error("Invalid Email ❌");
          break;

        case "auth/too-many-requests":
          toast.error(
            "Too many failed attempts. Try again later ❌"
          );
          break;

        default:
          toast.error("Login Failed ❌");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!username.trim()) {
      toast.error("Enter your email first 📧");
      return;
    }

    try {
      setLoading(true);

      await sendPasswordResetEmail(auth, username.trim());

      toast.success(
        "Password reset link sent successfully 📩"
      );
    } catch (error) {
      console.error(error);
      toast.error("Unable to send reset email ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <ToastContainer
        position="top-right"
        autoClose={2000}
      />

      <br />

      <div className="login-card">
        <div className="logo-container">
          <img
            src={logo}
            alt="Company Logo"
            className="login-logo"
          />
        </div>

        <h2 className="login-title">Welcome</h2>

        <p className="login-subtitle">
          Please login to your account
        </p>

        <form onSubmit={handleLogin}>
          {/* Email */}
          <div className="input-group">
            <FaUser className="input-icon" />

            <input
              type="email"
              placeholder="Email Address"
              value={username}
              onChange={(e) =>
                setUsername(e.target.value)
              }
              required
              autoFocus
            />
          </div>

          {/* Password */}
          <div className="input-group">
            <FaLock className="input-icon" />

            <input
              type={
                showPassword ? "text" : "password"
              }
              placeholder="Password"
              value={password}
              onChange={(e) =>
                setPassword(e.target.value)
              }
              required
            />

            <span
              className="eye-icon"
              onClick={() =>
                setShowPassword(!showPassword)
              }
            >
              {showPassword ? (
                <FaEyeSlash />
              ) : (
                <FaEye />
              )}
            </span>
          </div>

          {/* Forgot Password */}
          <div className="auth-links">
            <span
              className="forgot-password"
              onClick={handleForgotPassword}
            >
              Forgot Password?
            </span>
          </div>

          {/* Login Button */}
          <button
            type="submit"
            disabled={loading}
            className="login-btn"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>

      <br />
    </div>
  );
};

export default Loginpage;